import { v4 as uuidv4, v5 as uuidv5 } from "uuid";

export const stripDashes = (value: string): string => value.replace(/-/g, "");

export const normalizeGuid = (value: string): string => stripDashes(value).toLowerCase();

export const sameGuid = (left: string, right: string): boolean => normalizeGuid(left) === normalizeGuid(right);

const GUID_PATTERN = /^[0-9a-f]{32}$/i;

const SCOPED_ID_NAMESPACE = "b7c1f2e4-9a3d-4c58-8f21-6d0e5a7b3c94";

export const isValidGuid = (value: string | undefined | null): boolean =>
	typeof value === "string" && GUID_PATTERN.test(value);

export const resolveWorkerId = (uuid: string | undefined): string => (uuid ? stripDashes(uuid) : "");

export const deriveScopedId = (seed: string, scope: string): string => {
	if (!seed) throw new Error("deriveScopedId requires a non-empty seed");
	if (!scope) throw new Error("deriveScopedId requires a non-empty scope");
	return stripDashes(uuidv5(`${seed}:${scope}`, SCOPED_ID_NAMESPACE));
};

const wsId = (): string => {
	const id = stripDashes(uuidv4());
	if (!id) throw new Error("wsId failed to generate a client id");
	return id;
};

export default wsId;
